"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (propValue, contextValue, defaultValue) {
  return propValue && propValue !== defaultValue ? propValue : contextValue || defaultValue;
};


//////////////////
// WEBPACK FOOTER
// ./~/better-react-spinkit/dist/util/preside.js
// module id = 417
// module chunks = 0